<div class="row">
  <div *ngFor="let _news of news" class="col-lg-3 col-md-6">
    <kt-content-news-card
      (btnClick)="newsClick.emit($event)"
      [news]="_news"></kt-content-news-card>
  </div>
</div>
